// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3ekZ0","inputDescription":"styles_inputDescription__2esJf"};